import React from "react";
import { IconSearch, IconBell, IconMenu, IconMetricool } from "../icons";

const PAGE_TITLES = {
  dashboard:   "Dashboard",
  objectifs:   "Objectifs",
  demandes:    "Demandes clubs",
  campagnes:   "Campagnes",
  calendrier:  "Calendrier",
  contenus:    "Contenus",
  projets:     "Projets & Tâches",
  evenements:  "Événements",
  kpi:         "KPI & Reporting",
  brand:       "Brand Center",
  equipe:      "Équipe",
  ressources:  "Ressources",
  formation:   "Formation",
  parametres:  "Paramètres",
  profil:      "Mon profil",
};

export default function Topbar({ currentPage, onMenuOpen, onToggleCollapse, collapsed = false, onOpenSearch, notifCount = 0, onNavigate, currentUser }) {
  const title = PAGE_TITLES[currentPage] || "—";
  const fullName = currentUser?.name || "Utilisateur";
  const firstName = fullName.split(" ")[0];
  const role = currentUser?.role || "";
  const initials = fullName.split(" ").map((w) => w[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();

  return (
    <header className="v2-topbar" role="banner">
      {/* Hamburger mobile */}
      <button
        className="v2-topbar__hamburger v2-btn v2-btn--icon"
        onClick={onMenuOpen}
        aria-label="Ouvrir la navigation"
      >
        <IconMenu size={20} />
      </button>

      {/* Réduire / agrandir le menu (desktop) */}
      <button
        className="v2-topbar__collapse"
        onClick={onToggleCollapse}
        aria-label={collapsed ? "Agrandir le menu" : "Réduire le menu"}
        aria-expanded={!collapsed}
        title={collapsed ? "Agrandir le menu" : "Réduire le menu"}
      >
        <IconMenu size={18} />
      </button>

      {/* Page title */}
      <h1 className="v2-topbar__title">{title}</h1>

      {/* Global search — ouvre la palette ⌘K */}
      <div className="v2-topbar__search">
        <button
          type="button"
          className="v2-search v2-search--btn"
          onClick={onOpenSearch}
          aria-label="Rechercher (Ctrl K)"
        >
          <IconSearch className="v2-search__icon" />
          <span className="v2-search__placeholder">Rechercher…</span>
          <span className="v2-search__kbd">Ctrl K</span>
        </button>
      </div>

      <div className="v2-topbar__spacer" />

      <div className="v2-topbar__actions">
        {/* Metricool external link */}
        <a
          href="https://app.metricool.com"
          target="_blank"
          rel="noopener noreferrer"
          className="v2-topbar__btn"
          title="Ouvrir Metricool"
          aria-label="Ouvrir Metricool"
        >
          <IconMetricool size={17} />
        </a>

        {/* Notifications */}
        <button
          className="v2-topbar__btn"
          aria-label={`Notifications${notifCount > 0 ? ` (${notifCount})` : ""}`}
        >
          <IconBell size={17} />
          {notifCount > 0 && <span className="v2-topbar__notif-dot" aria-hidden="true" />}
        </button>
      </div>

      {/* Utilisateur connecté (haut à droite) */}
      <button
        className="v2-topbar__user"
        onClick={() => onNavigate && onNavigate("profil")}
        title={`${fullName}${role ? ` — ${role}` : ""}`}
        aria-label={`Profil de ${fullName}`}
      >
        <span className="v2-topbar__user-av">{initials}</span>
        <span className="v2-topbar__user-info">
          <span className="v2-topbar__user-name">{firstName}</span>
          {role && <span className="v2-topbar__user-role">{role}</span>}
        </span>
      </button>
    </header>
  );
}
